export default {
  frontend_groovemember_left_panel_instructor_heading: 'Seu instrutor',
  frontend_groovemember_left_panel_membership_outline_heading: 'Módulos',
  frontend_groovemember_left_panel_progress_bar_heading: '% Concluído',
  frontend_groovemember_main_panel_add_comment: 'Adicione um novo comentário',
  frontend_groovemember_main_panel_comments_heading: 'Comentários',
  frontend_groovemember_main_panel_previous_button: 'Anterior',
  frontend_groovemember_main_panel_next_button: 'Marcar como concluído',
  frontend_groovemember_top_navbar_profile_dropdown_hey: 'Ei',
  frontend_groovemember_top_navbar_profile_dropdown_level: 'Nível',
  frontend_groovemember_top_navbar_profile_dropdown_settings: 'Definições',
  frontend_groovemember_top_navbar_profile_dropdown_back_to_portal: 'Voltar ao Portal',
  frontend_groovemember_top_navbar_profile_dropdown_logout: 'Sair',
  frontend_groovemember_course_edit_access_now: 'Acessar agora',
  frontend_groovemember_course_edit_learn_more: 'Saiba mais',
  frontend_instructors: 'Instrutores',
  frontend_content: 'Conteúdo', 
  frontend_groovemember_form_password: 'Senha', 
  frontend_groovemember_form_placeholder_email: 'Digite seu email',
  frontend_groovemember_form_placeholder_pass: 'Digite sua senha',
  frontend_groovemember_form_forgot_pass: 'Esqueci minha senha',
  frontend_groovemember_form_back_to_home: 'Voltar para a página inicial',
  frontend_groovemember_form_signin: 'Fazer login',
};



